import { createTheme, createVariant, globalTheme } from '@clds/component-theme';
const { palette, radius, shadow, spacing } = globalTheme;
export const paperTheme = createTheme({
    background: palette.surface,
    radiusVariant: {
        sm: {
            radius: radius.unstable_new.sm,
            padding: spacing.sm,
        },
        md: {
            radius: radius.unstable_new.md,
            padding: spacing.sm,
        },
        lg: {
            radius: radius.unstable_new.lg,
            padding: spacing.sm,
        },
        xl: {
            radius: radius.unstable_new.xl,
            padding: spacing.lg,
        },
    },
    depthVariant: {
        none: {
            shadow: 'none',
        },
        sm: {
            shadow: shadow.sm,
        },
        md: {
            shadow: shadow.md,
        },
        lg: {
            shadow: shadow.lg,
        },
    },
}, 'paper');
export const radiusVariant = createVariant(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => paperTheme.radiusVariant[props.borderRadius || 'md']);
export const depthVariant = createVariant(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => paperTheme.depthVariant[props.depth || 'md']);
//# sourceMappingURL=theme.js.map